module.exports = __webpack_public_path__ + "static/img/003@2x.6e14549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/003@2x.png
// module id = zFTY
// module chunks = 1